export default {
  LOADING_TABLE: 'ACCOUNTS_VIEW_CONTRACT_VALUATIONS_LOADING_TABLE',
  LOADED_TABLE: 'ACCOUNTS_VIEW_CONTRACT_VALUATIONS_LOADED_TABLE',
};
